import customFetch from '../customFetch';

const API_URL = process.env.VUE_APP_MACHETE_BALANCES_API_URL;

export default {
  async getAllDebts(query) {
    const response = await customFetch(`${API_URL}/debts`, { query });

    const { payload } = await response.json();

    return payload;
  },

  async getDebtsInMonth({ year, month }) {
    const response = await customFetch(`${API_URL}/debts/by-month/:month`, {
      query: { year },
      params: { month },
    });

    const { payload } = await response.json();

    return payload;
  },

  async getDebtsSummary() {
    const response = await customFetch(`${API_URL}/debts/summary`);

    const { payload } = await response.json();

    return payload;
  },

  async getAllDebtsExpired(query) {
    const response = await customFetch(`${API_URL}/debts/expired`, { query });

    const { payload } = await response.json();

    return payload;
  },

  async getAllDebtsCustomer(query) {
    const response = await customFetch(`${API_URL}/debts/customer`, { query });

    const { payload } = await response.json();

    return payload;
  },

  async customersGetAllDebts() {
    const response = await customFetch(`${API_URL}/customers/debts`);

    const { payload } = await response.json();

    return payload;
  },

  async customersGetAllDebtsExpired() {
    const response = await customFetch(`${API_URL}/customers/debts/expired`);

    const { payload } = await response.json();

    return payload;
  },

  async customersGetAllDebtsCustomer() {
    const response = await customFetch(`${API_URL}/customers/debts/customer`);

    const { payload } = await response.json();

    return payload;
  },

  async customersGetDebtsCreditLimit() {
    const response = await customFetch(`${API_URL}/customers/debts/limit`);

    const { payload } = await response.json();

    return payload;
  },

  async getDebtsCreditLimit(query) {
    const response = await customFetch(`${API_URL}/debts/credit/limit`, { query });

    const { payload } = await response.json();

    return payload;
  },
};
